import React from 'react';

import styles from './NavigationItems.module.css';
import NavigationItem from './NavigationItem/NavigationItem';

const navigationItems = ( props ) => (
    <ul className={styles.NavigationItems}>
        {props.isAuthenticated ? <NavigationItem link="/" exact>Flight Info</NavigationItem> : null}
        {props.isAuthenticated ? <NavigationItem link="/report" exact>Reports</NavigationItem> : null}
        {!props.isAuthenticated
            ? <NavigationItem link="/auth">Login/Signup</NavigationItem>
            : <NavigationItem link="/logout">Logout</NavigationItem>}
    </ul>
);

export default navigationItems;